<style src="./SuppliersListing.scss" lang="scss" scoped></style>
<template>
  <section class="suppliers">
    <content-header path="Cadastro / Fornecedores"/>

    <form v-on:submit.prevent="">
      <section class="form-box row">
        <textbox
          class="col-9"
          v-model="filter.searchText"
          label="Buscar Fornecedor"
          placeholder="Digite o nome do fornecedor"
          :autofocus="true"
          :debounce="250"
          @debounce="searchSupplier"/>

        <button class="btn-primary col-3" @click="addNew">
          <icon-add />
          <span class="hide-md">Novo Fornecedor</span>
        </button>
      </section>
    </form>

    <section class="form-box">
      <page-navigator
        :total-pages="paginator.totalPage"
        :per-page="paginator.perPage"
        v-model="paginator.actualPage" />

      <suppliers-map
        :list="filteredList" />
    </section>
  </section>
</template>

<script>
import ContentHeader from '@/components/foundation/content-header/ContentHeader'
import SuppliersMap from './components/suppliers-map/SuppliersMap'
import { Textbox, SourcePaginatorMixin, PageNavigator } from '@/components/primitives'
import { IconAdd, IconEmpty } from '@/components/primitives/icons'
import { SearchSuppliers } from '@/brain/record/suppliers'

export default {
  name: 'SuppliersListing',
  components: {
    ContentHeader,
    SuppliersMap,
    Textbox,
    IconAdd,
    IconEmpty,
    PageNavigator
  },
  extends: {
    ...SourcePaginatorMixin
  },
  data () {
    return {
      filter: {
        searchText: ''
      },
      filteredList: []
    }
  },
  watch: {
    paginator: {
      handler () {
        this.searchSupplier()
      },
      deep: true
    }
  },
  mounted () {
    this.filter.searchText = this.$route.query.s
    this.searchSupplier()
  },
  methods: {
    addNew () {},
    searchSupplier () {
      if (this.filter.searchText.length < 2 && this.filter.searchText.length > 0) {
        this.filteredList = []
        this.paginator.totalRegister = 0
        this.paginator.totalPage = 0
        return false
      }

      this.$router.replace({
        query: {
          s: this.filter.searchText
        }
      })
      const params = this.buildQuery({ filters: this.filter })

      SearchSuppliers({ params })
        .then((result) => {
          this.filteredList = result.list
          this.paginator.totalRegister = result.rows
          this.paginator.totalPage = Math.floor(result.rows / this.paginator.perPage)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/record/suppliers/suppliers-listing/SuppliersListing.vue